import {Fragment, useState, useEffect} from 'react';
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import styles from './pagination.module.css';

export default function Pagination({ prevPageNumberLength, pageNumbers, currentPage, handleChangePage, handleClickFunctionKeys }) {
    const [localPageNumbers, setLocalPageNumbers] = useState([]);

    const calculatePageRange = () => {
        const step = 10;
        const lowerBound = Math.floor((currentPage - 1) / step) * step + 1;
        const upperBound = lowerBound + step - 1;
        setLocalPageNumbers(pageNumbers.slice(lowerBound - 1, upperBound));
    };

    useEffect(() => {
        calculatePageRange();
    }, [currentPage, pageNumbers]);

    useEffect(() => {
        if (!pageNumbers) return;
        if (prevPageNumberLength > pageNumbers.length && currentPage > pageNumbers.length) handleClickFunctionKeys(0);
    }, [pageNumbers]);

    return (
        <div className={styles.wrapper}>
            <button className={styles.btn} disabled={pageNumbers.length < 1 || currentPage === 1} onClick={e => handleClickFunctionKeys(0)}><MdKeyboardDoubleArrowLeft style={{marginRight: '4px', color: 'var(--gray_blue_dark)'}}/>처음</button>
            <button className={styles.btn} disabled={currentPage === 1 || pageNumbers.length < 10} onClick={e => handleClickFunctionKeys(1)}>이전</button>
            {localPageNumbers.map((number, index) => (
                <Fragment key={`pagination-${index}`}>
                  {<button key={number} onClick={() => handleChangePage(number)}
                            className={currentPage === number ? styles.btnActive : styles.btn}>
                      {number}
                    </button>
                  }
                </Fragment>
            ))}
            <button className={styles.btn} disabled={pageNumbers.length < 10 || currentPage === pageNumbers[pageNumbers.length - 1]} onClick={e => handleClickFunctionKeys(2)}>다음</button>
            <button className={styles.btn} disabled={pageNumbers.length < 1 || currentPage === pageNumbers[pageNumbers.length - 1]} onClick={e => handleClickFunctionKeys(3)}>마지막<MdKeyboardDoubleArrowRight style={{marginLeft: '4px', color: 'var(--gray_blue_dark)'}}/></button>
        </div>
    )
}
